import React from 'react'
import PageList from '../cn/pageList'
import { Spring } from 'react-spring'

const Menu = () => (
  <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
    {props => (
      <div style={props}>
        <Nav />
      </div>
    )}
  </Spring>
)

const Nav = () => (
  <nav className="menu">
    <PageList />
  </nav>
)

export default Menu
